
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcac as ObiConverterDcacElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcac.js';
 
 
 

 
 export const ObiConverterDcac = createComponent({
   react: React,
   tagName: 'obi-converter-dcac',
   elementClass: ObiConverterDcacElement,
   events: {
     
   }
  });
 
 